/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";

const LinkPlacementsWarning = (props) => {

    const { showMultipleWarning } = props;

    return (
        <Fragment>
            {showMultipleWarning &&
                <div style={{ padding: "8px 6px 8px 6px", fontSize: "11px" }}>
                    <em>This link is used on more than one webpage. Editing this link will
                        affect all places where it is used.</em>
                </div>
            }
        </Fragment>
    );
};

export { LinkPlacementsWarning };
